var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-login-body" },
    [
      _vm._m(0),
      _c(
        "el-row",
        { staticClass: "el-login-main " },
        [
          _c(
            "el-col",
            { staticClass: "hello-banner flex-center", attrs: { span: 14 } },
            [
              _c("img", {
                attrs: { src: require("@/assets/images/welcome.png") },
              }),
            ]
          ),
          _c(
            "el-col",
            { staticClass: "logo-content", attrs: { span: 10 } },
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-banner" }, [
      _c("img", { attrs: { src: require("@/assets/images/logo.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }